export const supportedOtherRecordKeys = ['abi'] as const
